import _ from 'lodash';
import moment from 'moment';

export const composeBarChartData = (data, fields, labelField, labelSuffix) => fields.map(field =>
  data.map(row =>
    ({
      x: row[labelField].toString(),
      y: row[field],
      label: labelSuffix ? `${row[field]} ${labelSuffix}` : row[field],
    })));

export const shortenDateLabels = (data, dateField) => _.map(data, (row) => {
  const check = moment(row[dateField]);
  return `${check.format('DD')}/${check.format('MM')}`;
});

const receptacleCount = {
  title: 'Receptacle Count',
  type: 'stackedColumn',
  fields: [{
    name: 'PREDES with RESDES',
    color: '#7dbd7b',
  }, {
    name: 'PREDES without RESDES',
    color: '#ef696e',
  }],
  yTickFormat: amount => amount,
  xTickValues: data => shortenDateLabels(data, 'despatchClosedDate'),
  composeChartData: data => composeBarChartData(
    data,
    ['predesWithResdesCount', 'predesWithoutResdesCount'],
    'despatchClosedDate',
  ),
};

const receptacleWeight = {
  title: 'Receptacle Weight',
  type: 'stackedColumn',
  fields: [{
    name: 'PREDES with RESDES',
    color: '#7dbd7b',
  }, {
    name: 'PREDES without RESDES',
    color: '#ef696e',
  }],
  yTickFormat: amount => `${amount} kg`,
  xTickValues: data => shortenDateLabels(data, 'despatchClosedDate'),
  composeChartData: data => composeBarChartData(
    data,
    ['predesWithResdesWeight', 'predesWithoutResdesWeight'],
    'despatchClosedDate',
    'kg',
  ),
};

const eventTargets = {
  title: 'Event Targets',
  type: 'stackedColumn',
  fields: [{
    name: '<= CST %',
    color: '#7dbd7b',
  }],
  yTickFormat: number => `${number} %`,
  xTickValues: data => shortenDateLabels(data, 'despatchClosedDate'),
  composeChartData: data => composeBarChartData(
    data,
    ['onTimeCSTPercentage'],
    'despatchClosedDate',
    '%',
  ),
};

export default {
  eventTargets,
  receptacleCount,
  receptacleWeight,
};
